// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_6o-6";
export var headerCell = "_6o-2";
export var rowWrapper = "_6o-4";
export var stickyAggregationCell = "_6o-a";
export var stickyAggregationRow = "_6o-7";
export var stickyColumnCell = "_6o-9";
export var stickyColumnHeaderCell = "_6o-8";
export var table = "_6o-1";
export var virtualRowWrapper = "_6o-5";
export var virtualTableContainer = "_6o-0";
export var white = "_6o-3";